import ModalCloseButton from 'components/buttons/ModalCloseButton'
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { setViewResponsesModal, viewResponses } from 'features/polls/pollSlice' 
import OpenResponses from './OpenResponses'
import PredeterminedResponses from './PredeterminedResponses'
import SpinnerSmall from 'components/SpinnerSmall'
import { useTranslation } from 'react-i18next'

export default function PollResponseModal({ pollId }) {
    const { t } = useTranslation('polls')

    const dispatch = useDispatch()
    const { viewResponsesModal, viewResponsesStatus, responseData } = useSelector( (state) => state.poll) 
    const { profileChurch } = useSelector( (state) => state.profileChurch)
    
    useEffect(() => {
        
        dispatch(viewResponses({
            pollId:  viewResponsesModal.pollId,
            churchId: profileChurch ? profileChurch._id : null
        }))


    }, [])

    return (
        <PollResponsesModalContainer> 
            <ModalCloseButton size="30px" handler={ () =>  { dispatch(setViewResponsesModal(false)) } }  />  
            {
                viewResponsesStatus === "LOADING" ? (
                    <div  style={{ width: "100%", height: "80%", display: "flex", alignItems: "center", justifyContent: "center" }} >
                        <SpinnerSmall border = {"#727272"} />
                    </div>
                    
                ) 
                : viewResponsesStatus === "SUCCESS" && responseData && responseData.participants && responseData.participants.length > 0 ?
                (
                    <ResponsesContainer>
                        <div
                            style={{
                                width: "100%", 
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "flex-start",
                                color: "var(--lightThemeFontColor)", 
                                fontSize: "14px",
                                marginBottom: "15px"
                            }}
                            >
                            {t('results.title')}
                        </div>

                        <ResponsesItems>
                            {
                                responseData.responseType === 'open' ? 
                                (
                                    <OpenResponses pollData={responseData} />
                                ) : (
                                    <PredeterminedResponses pollData={responseData} />
                                )
                            }
                        </ResponsesItems>

                    </ResponsesContainer>
                )
                : 
                (
                    <ResponsesContainer>
                        <div>
                            {t('management.noResponses')}
                        </div>
                    </ResponsesContainer>
                )
            }
        </PollResponsesModalContainer>
    )
}

const ResponsesItems = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start; 
    color: var(--lightThemeFontColor);
    z-index: 0;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 10px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
        background: #888;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

`

const ResponsesContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 20px;
    color: var(--lightThemeFontColor);
    z-index: 0;

`

const PollResponsesModalContainer = styled.div`
    width: 600px;
    height: 400px;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    align-items: flex-start;
    background-color: white;
    justify-content: flex-start;
    padding: 20px;
    color: var(--lightThemeFontColor);
    position: relative;
`
